// extracted by mini-css-extract-plugin
module.exports = {"page":"Company_page__3CHfX","content":"Company_content__2n8lg"};